import styled from "styled-components";

export const NovaSolicitacaoBtn = styled.button`
  width: 100%;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 16px;
  transition: 0.3s;
  border: 2px solid ${(props) => props.bg};
  &:hover {
    box-shadow: 0px 0px 8px ${(props) => props.bg};
  }
  a {
    text-decoration: none;
    width: 100%;
    height: 100%;
    text-transform: uppercase;
    color: #ffffff;
    background-color: ${(props) => props.bg};
    font-size: 18px;
    font-weight: bold;
    svg {
      margin-right: 4px;
    }
  }
  @media (max-width: 768px) {
    a {
      font-size: 16px;
    }
  }
`;
